export default __webpack_public_path__ + "static/puzzle-5fed57c87a1aa24c2e3d97288b99c10f.png";